import { t } from "@lingui/macro";
import { useAtomValue } from "jotai";

import { getManualPaymentStatusOnGuestRoundAtom } from "@/screens/BookingDetail/NewPatronBookingFlow/components/EditBooking/atoms/selectors/getManualPaymentStatusOnGuestRound/getManualPaymentStatusOnGuestRound";
import { Text } from "@whoosh/design-system/src/components/primitive";

type Props = {
  roundId: string;
};

export const BillMemberDisplay = ({ roundId }: Props) => {
  const manualPaymentStatus =
    useAtomValue(getManualPaymentStatusOnGuestRoundAtom(roundId)) ||
    "AUTO_CHARGE";

  return (
    <>
      <Text variant="mainTiny" color="text-secondary">{t`Bill Member`}</Text>
      <Text variant="mainSmallSemiBold" color="text-primary">
        {manualPaymentStatus === "AUTO_CHARGE" ? t`Yes` : t`No`}
      </Text>
    </>
  );
};
